module.exports = __webpack_public_path__ + "img/EarClip.0d7f761f.jpg";